import { Section, SectionTitle, CaseCard } from './shared';

export function HealthContent() {
  const healthCases = [
    {
      icon: '❤️',
      title: '专属营养师',
      description: '把 OpenClaw 训练成专属营养师,提供个性化的饮食建议和健康追踪',
      tags: ['健康', '营养', 'AI助手'],
      difficulty: 'beginner' as const,
      link: 'https://curl.qcloud.com/hdsYWvoY',
    },
  ];

  return (
    <div className="space-y-8">
      <Section>
        <SectionTitle>健康管理案例</SectionTitle>
        <p className="text-slate-400 mb-6">
          使用 OpenClaw 构建个性化健康管理系统,实现饮食追踪、运动记录和健康建议。
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {healthCases.map((caseItem, index) => (
            <CaseCard key={index} {...caseItem} />
          ))}
        </div>
      </Section>

      <Section>
        <div className="bg-cyan-500/10 border border-cyan-500/50 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-cyan-400 mb-3">💡 健康功能</h3>
          <ul className="space-y-2 text-slate-300">
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>个性化饮食建议和营养分析</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>运动计划制定和追踪</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>健康数据记录和可视化</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>定期健康提醒和建议</span>
            </li>
          </ul>
        </div>
      </Section>
    </div>
  );
}